exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.main {\n  padding: 1ex;\n  margin: 1ex;\n  border: 2px silver solid;\n}\n\ndiv.main div {\n  margin: 0.8ex;\n}\n\nspan.isOn {\n  background: yellow;\n}\n\nspan.user {\n  margin:2px 8px;\n  display: inline-block;\n  padding: 2px 7px;\n  cursor: poiner;\n  border: thin solid silver;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/project-db-records-stats/project-db-records-stats.component.css
// module id = ../../../../../src/app/project-db-records-stats/project-db-records-stats.component.css
// module chunks = main